import { render } from "./Jack.vue?vue&type=template&id=4facadeb"
const script = {}

import "./Jack.vue?vue&type=style&index=0&id=4facadeb&lang=less&scope=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__